export default "__VITE_ASSET__CxYACo4x__"